import { UseNavigateReturnType } from '@alfa-retail-react/components/navigate-hook';

import { getExceptionHandler } from 'app/api/getExceptionHandler';
import {
    CreditCardOrderRejectedException,
    TRejectCode,
} from 'app/api/exception/CreditCardOrderRejectedException';
import { ERROR_PAGE_URL } from 'app/logic/pages/error/ErrorPage';
import { ReturnAnalyticsType } from 'app/analytics/useAnalytics';
import { ReactNode } from 'react';

const ERROR_PAGE_TITLE_KEY = 'creditCard_error_reject_page_title';

const MSI_ACTUALIZATION_TITLE_KEY =
    'creditCard_error_reject_msi_actualization_title';
const MSI_ACTUALIZATION_ACTION_KEY =
    'creditCard_error_reject_msi_actualization_action';

const SDBO_TITLE_KEY = 'creditCard_error_reject_sdbo_title';
const SDBO_MESSAGE_KEY = 'creditCard_error_reject_sdbo_message';

const getErrorPageParams = (
    rejectCode: TRejectCode,
    translate: (
        key: string | [string, ...Array<string | ReactNode>],
    ) => string | ReactNode,
) => {
    switch (rejectCode) {
        case TRejectCode.personalData: {
            return {
                title: translate(MSI_ACTUALIZATION_TITLE_KEY),
                actionHandler: () => {
                    window.open(
                        (window as any).env.MSI_EDIT_PERSONAL_DATA_URL,
                        '_blank',
                    );
                },
                actionButtonText: translate(MSI_ACTUALIZATION_ACTION_KEY),
            };
        }
        case TRejectCode.SDBO: {
            return {
                title: translate(SDBO_TITLE_KEY),
                messages: [translate(SDBO_MESSAGE_KEY)],
            };
        }
        default: {
            return {};
        }
    }
};

/**
 * Обработчик исключения, возникаемого при отказе в удовлетворении заявки.
 * Представляет собой набор действий для исключения типа {@link CreditCardOrderRejectedException}
 * @param navigate
 * @param analytics
 */
export const orderRejectedExceptionHandler = (
    navigate: UseNavigateReturnType,
    analytics?: ReturnAnalyticsType,
    translate?: (
        key: string | [string, ...Array<string | ReactNode>],
    ) => string | ReactNode,
) => {
    return getExceptionHandler(
        CreditCardOrderRejectedException.NAME,
        (exception: CreditCardOrderRejectedException) => {
            analytics?.fullEvent('OrderRejectEventOccurred');

            const params = {
                title: translate(ERROR_PAGE_TITLE_KEY),
                messages: exception.rejectReasons,
                ...getErrorPageParams(exception.rejectCode, translate),
            };

            navigate(ERROR_PAGE_URL, params);
        },
    );
};
